import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("确认");

import { computed, reactive, ref, watch } from 'vue';
import { saveCategory } from '@/request';
import { ElMessage } from 'element-plus/lib/components';
export default {
  name: 'AddCategoryModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    dept: {
      type: Object,
      default: () => ({})
    },
    supplierId: {
      type: String,
      defualt: ''
    },
    data: {
      type: [Object, null],
      defualt: null
    },
    categoryList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    let form = reactive({
      categoryName: ''
    });
    let formRef = ref();
    watch(() => props.modelValue, newVal => {
      if (!newVal) {
        form.categoryName = '';
      }

      if (newVal && props.data) {
        formRef.value.resetFields();
        form.categoryName = props.data.typeName;
      }
    }, {
      flush: 'post'
    });

    function confirm() {
      formRef.value.validate(e => {
        if (e) {
          let payload = {
            typeName: form.categoryName,
            supplierId: props.supplierId,
            structureId: props.supplierId === props.dept.id ? '' : props.dept.id
          };

          if (props.data) {
            payload.merTypeId = props.data.merTypeId;
          }

          saveCategory(_objectSpread(_objectSpread({}, payload), {}, {
            __repeat: true,
            __warn: true
          })).then(data => {
            if (data.success) {
              ElMessage.success('操作成功!');
              visible.value = false;
              emit('success', form);
            }
          });
        }
      });
    }

    function validhasSameCate(rule, value, callback) {
      if (props.categoryList.some(i => i.typeName === value)) {
        callback(new Error('已存在相同分类, 请重新输入分类'));
      } else {
        callback();
      }
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(visible) ? visible.value = $event : null),
        title: props.data ? '编辑' : '新增',
        width: "600px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: _unref(form)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "分类名称",
            prop: "categoryName",
            rules: [{
              required: true,
              message: '请填写分类名称',
              trigger: 'blur'
            }, {
              min: 1,
              max: 4,
              message: '长度在 1 到 4 个字符',
              trigger: 'blur'
            }, {
              validator: validhasSameCate,
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).categoryName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).categoryName = $event),
              modelModifiers: {
                trim: true
              },
              maxlength: "4",
              minlength: "1"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }

};